export const handleMobileAccess = (
  remoteConfig: models.RemoteConfig | null
) => {
  const userAgent = navigator.userAgent;
  if (remoteConfig) {
    if (/iPhone|iPod|iPad/i.test(userAgent) && remoteConfig.ios?.storeUrl) {
      alert(remoteConfig.ios?.storeUrl);
      window.location.assign(remoteConfig.ios.storeUrl);
    }

    if (/Android/i.test(userAgent) && remoteConfig.android?.storeUrl) {
      window.location.assign(remoteConfig.android.storeUrl);
    }
  }

  return;
};
